import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Track from '../Track';

export function VideoInfo({ listing }) {
  return (
    <>
      <Track track={listing.track} />
      {listing.version ? (
        <FormattedMessage
          defaultMessage=" (v{version})"
          id="11eca"
          values={{ version: listing.version }}
        />
      ) : (
        <FormattedMessage defaultMessage=" (Not Provided)" id="824a8" />
      )}
    </>
  );
}

VideoInfo.propTypes = {
  listing: PropTypes.shape({
    track: PropTypes.string,
    version: PropTypes.string,
  }).isRequired,
};

export default { VideoInfo };
